import {
  Navigate,
  Outlet,
  useLocation,
} from 'react-router-dom';

import useAuth from './useAuth';

/**
 * A route behind one right, or behind any of several when `right` is an array.
 *
 * `scope="anywhere"` lets a right held inside a single department open the
 * route — the door asks whether the person administers *something*, and the
 * page then shows only what their rights allow. The default is the strict
 * reading, platform-wide, matching the server's own default.
 *
 * This is a redirect, not a guard: the guard is on the endpoints. A page that
 * opens without data is worse than a page that never opens, which is all this
 * prevents.
 */
export default function RightRoute({ right, scope = 'global' }) {
  const { isAuthenticated, isLoading, user } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return null;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  const held =
    scope === 'anywhere'
      ? user?.rightsAnywhere
      : user?.rights;

  // Several rights mean any one of them opens the route.
  const accepted = Array.isArray(right) ? right : [right];

  if (!accepted.some((r) => held?.includes(r))) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
